function formatQueryString(queryObj) {
  return Object.entries(queryObj).reduce((acc, [key, value], index) => {
    if (index === 0) {
      return `?${key}=${value}`;
    }
    return `${acc}&${key}=${value}`;
  }, '');
}

/**
 * Format an url based on pathname and a query object, similar to react router
 * Link does with "to" prop. This doesn't support things like hash yet.
 */
export default function formatUrl({ pathname, query }) {
  return `${pathname}${formatQueryString(query)}`;
}



// WEBPACK FOOTER //
// ./src/helpers/formatUrl.js